import { render, staticRenderFns } from "./ValueChainProperties.vue?vue&type=template&id=282b62a4&scoped=true&"
import script from "./ValueChainProperties.vue?vue&type=script&lang=js&"
export * from "./ValueChainProperties.vue?vue&type=script&lang=js&"
import style0 from "./ValueChainProperties.vue?vue&type=style&index=0&id=282b62a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b62a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VForm,VTreeview})
